import { render, staticRenderFns } from "./importTeacher.vue?vue&type=template&id=130c2d76&"
import script from "./importTeacher.vue?vue&type=script&lang=js&"
export * from "./importTeacher.vue?vue&type=script&lang=js&"
import style0 from "./importTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports